import React from 'react';
import { sources } from '../../constants/documentConfig';

const ApplicationSource = ({ applicationSource, jobDescription, onToggle, onTextChange, onJobDescriptionChange }) => {
  const hasActiveSource = sources.some((s) => applicationSource[s.key]?.selected);

  return (
    <div>
      <div className="source-tabs">
        {sources.map((source) => (
          <button
            key={source.key}
            type="button"
            className={`source-tab${applicationSource[source.key].selected ? ' source-tab--active' : ''}`}
            onClick={() => onToggle(source.key, !applicationSource[source.key].selected)}
            title={source.tooltip}
          >
            {source.label}
          </button>
        ))}
      </div>

      {!hasActiveSource && (
        <div style={{ fontSize: '12px', color: '#7A90B5', padding: '10px 0' }}>
          Select a source type above to add context for your application documents.
        </div>
      )}

      {sources.map((source) => {
        if (!applicationSource[source.key].selected) return null;
        const value = source.key === 'jobDescription' ? jobDescription : applicationSource[source.key].text;
        const showCounter = value.length >= source.maxLength * 0.9;
        return (
          <div key={source.key} className="source-area">
            <div className="source-area-label">{source.label}</div>
            <textarea
              className="input"
              rows="5"
              maxLength={source.maxLength}
              placeholder={source.placeholder}
              value={value}
              onChange={(e) =>
                source.key === 'jobDescription'
                  ? onJobDescriptionChange(e.target.value)
                  : onTextChange(source.key, e.target.value)
              }
            />
            {showCounter && (
              <div className="field-char-count">
                {value.length.toLocaleString()} / {source.maxLength.toLocaleString()}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ApplicationSource;
